export const MATCH_ID_QUERY_KEY = 'matchId';
export const TOURNAMENT_ID_QUERY_KEY = 'tournamentId';
